import apiService from '../Api'
import IFilter, {
  IExperienceFeedbackAnswer,
  IExperienceFeedbackListResponse,
  IExperienceFeedbackStorePayload
} from './interfaces'

export default class ExperienceFeedbackService {
  async getQuestion(feedbackId: number) {
    return apiService.get(`/experience-feedback/question/${feedbackId}`)
  }

  async getExperienceFeedback(id: number) {
    return apiService.get(`/experience-feedback/${id}`)
  }

  async getAnswers(id: number) {
    return apiService.get(`/experience-feedback/answers/${id}`)
  }

  async list(filter: IFilter): Promise<IExperienceFeedbackListResponse> {
    // `params: filter` on purpose: Api.ts serializes the nested `date` object as JSON,
    // which is what the backend reads. URLSearchParams would flatten it and break the filter.
    return apiService
      .get<IExperienceFeedbackListResponse>(`/experience-feedback`, { params: filter })
      .then((response) => response.data)
  }

  async store(data: IExperienceFeedbackStorePayload) {
    return apiService.post(`/experience-feedback/`, data)
  }

  async update(id: number, data: IExperienceFeedbackAnswer) {
    return apiService.post(`/experience-feedback/${id}`, data)
  }

  async delete(id: number) {
    return apiService.delete(`/experience-feedback/${id}`)
  }

  async previousStep(id: number) {
    return apiService.post(`/experience-feedback/previous/${id}`)
  }
}
